import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import Lanmu from "@/pages/lanmu/page";
import Pindao from "@/pages/pindao/page";
import Wenzhang from "@/pages/wenzhang/page";
import Guanyu from "@/pages/guanyu/page";
import Changjianwenti from "@/pages/changjianwenti/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "lanmu", element: <Lanmu /> },
      { path: "pindao/:slug", element: <Pindao /> },
      { path: "wenzhang/:slug", element: <Wenzhang /> },
      { path: "guanyu", element: <Guanyu /> },
      { path: "changjianwenti", element: <Changjianwenti /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;